import i18n from "i18next";
import {fetchGameMessage, fetchGameMessageSuccess} from "modules/actions/gameMessage";
import Api from "modules/utils/Api";
import {call, put} from "typed-redux-saga";

const fetchGameMessageSaga = function* (_action: ReturnType<typeof fetchGameMessage>) {
	const result = yield* call(Api.Jsons.game_message);

	if (result?.data.messages?.length) {
		const message = result.data.messages.find((it) => it.language === i18n.language);

		if (message && !!message?.text.trim()) {
			yield* put(fetchGameMessageSuccess(message));
		}
	}
};

export default fetchGameMessageSaga;
